<template>
  <settings-modal
    :locked="loading"
    class="edit-aml-comment-modal"
  >
    <template slot="heading">Edit AML comment</template>

    <div class="aml-comment-date-group">
      <v-layout
        class="row--data"
        row
      >
        <v-flex xs4>
          <v-subheader class="v-subheader--dense">AML comment</v-subheader>
        </v-flex>
        <v-flex xs8>
          <v-textarea
            id="aml-comment"
            v-model="form.amlComment"
            label="AML comment"
            :counter="2000"
            :error-messages="getValidationErrorMessage('amlComment')"
          />
        </v-flex>
      </v-layout>
    </div>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onSaveButtonClick"
      >save</v-btn>

      <v-btn
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Mixins
  import form from '@/mixins/form'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert.vue'

  export default {
    components: {
      SettingsModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        form: { amlComment: null },
        amlCommentUpdateApiRequest: new ApiRequest(PaymentApi.updateAmlComment)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      paymentId () {
        return this.modal.data.paymentId
      },
      currentAmlComment () {
        return this.modal.data.amlComment
      },
      loading () {
        return this.amlCommentUpdateApiRequest.loading
      },
      error () {
        return this.amlCommentUpdateApiRequest.error
      }
    },
    created () {
      this.initFormData()
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      initFormData () {
        this.form.amlComment = this.currentAmlComment
      },
      onSaveButtonClick () {
        this.amlCommentUpdateApiRequest
          .execute(this.paymentId, this.form.amlComment)
          .then(this.amlCommentEditSuccessHandler)
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      amlCommentEditSuccessHandler () {
        this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'AML comment has been successfully edited.' }
          })
        }, 100)
      }
    }
  }
</script>
